import enLang from './en_US';
import trLang from './tr_TR';

const AppLocale: any = {
  en: enLang,
  tr: trLang,
};

export default AppLocale;
